{
	"action": {
		"notification_broadcast_send": "Notification sent",
		"operator_activated": "User activated",
		"operator_deactivated": "User deactivated",
		"operator_invitation_email_changed": "User invitation email changed",
		"operator_invitation_resent": "User invitation resent",
		"operator_invitation_revoked": "User invitation revoked",
		"operator_invited": "User invited",
		"operator_reactivated": "User reactivated",
		"operator_removed": "User removed",
		"organization_created": "Organization created",
		"organization_reactivated": "Organization reactivated",
		"organization_storage_destroyed": "Organization deleted",
		"organization_suspended": "Organization suspended",
		"user_invite_resent": "Invitation resent",
		"user_invited": "Invitation sent",
		"user_mfa_reset": "2FA reset"
	},
	"columns": {
		"action": "Action",
		"admin": "Admin",
		"detail": "Detail",
		"organization": "Organization",
		"timestamp": "Date and time"
	},
	"detail": {
		"failure_code": "Code: {{code}}",
		"invite_resent": "Send #{{count}}",
		"storage_destroyed": "Files and folders: {{nodes}} · Versions: {{versions}}"
	},
	"empty": {
		"description": "As soon as something happens in this console it appears here, the most recent first.",
		"no_matches_description": "No act matches the current filters.",
		"no_matches_title": "No results",
		"title": "Nothing has been recorded yet"
	},
	"filters": {
		"action": "Action",
		"organization": "Organization",
		"organization_placeholder": "Search organization",
		"organization_unknown": "Unknown organization",
		"period": "Period"
	},
	"no_value": "Not available",
	"outcome": {
		"failure": "Failed"
	},
	"page_title": "Audit log"
}
